<template>
  <a-drawer width="65%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" labelAlign="left" :model="form" :rules="rules">
      <a-row>
        <a-col :span="24">
          <a-form-model-item prop="batchName" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <span slot="label"><a-tooltip>{{ $t('批次名称') }}<template slot="title">{{ $t('批次名称') }}</template></a-tooltip> </span>
            <a-input v-model="form.batchName" :maxLength="255" :placeholder="$t('请输入')+'批次名称'">
            </a-input>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-model-item prop="batchType" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
            <span slot="label"><a-tooltip>{{ $t('批次标签') }}<template slot="title">{{ $t('批次标签') }}</template></a-tooltip> </span>
            <a-select :placeholder="$t('请选择')+$t('批次标签')" style="width: 100%" v-model="form.batchType" allowClear>
              <a-select-option v-for="(item, index) in this.customDict.SchoolBatchTypeEnum" :value="item.type" :key="index">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item prop="logisticsType" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
            <span slot="label"><a-tooltip>{{ $t('物流类型') }}<template slot="title">{{ $t('物流类型') }}</template></a-tooltip> </span>
            <a-select :placeholder="$t('请选择')+$t('物流类型')" style="width: 100%" v-model="form.logisticsType" allowClear>
              <a-select-option v-for="(item, index) in filteredDeliveryOptions()" :value="item.type" :key="index">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-model-item prop="startTime" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
            <span slot="label"><a-tooltip>{{ $t('开始时间') }}<template slot="title">{{ $t('开始时间') }}</template></a-tooltip> </span>
            <a-date-picker style="width: 100%" v-model="form.startTime" :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item prop="endTime" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
            <span slot="label"><a-tooltip>{{ $t('结束时间') }}<template slot="title">{{ $t('结束时间') }}</template></a-tooltip> </span>
            <a-date-picker style="width: 100%" v-model="form.endTime" :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-model-item prop="mobile" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
            <span slot="label"><a-tooltip>{{ $t('客服电话') }}<template slot="title">{{ $t('客服电话') }}</template></a-tooltip> </span>
            <a-input v-model="form.mobile" :maxLength="20" :placeholder="$t('请输入')+'客服电话'">
            </a-input>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item prop="isShowNotification" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
            <span slot="label"><a-tooltip>{{ $t('是否展示公告') }}<template slot="title">{{ $t('是否展示公告') }}</template></a-tooltip> </span>
            <a-radio-group v-model="form.isShowNotification" button-style="solid">
              <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row v-if="form.isShowNotification">
        <a-col :span="24">
          <a-form-model-item prop="notification" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <span slot="label"><a-tooltip>{{ $t('公告内容') }}<template slot="title">{{ $t('公告内容') }}</template></a-tooltip> </span>
            <a-input v-model="form.notification" :placeholder="$t('请输入')" type="textarea" allow-clear/>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col :span="24">
          <a-form-model-item prop="notice" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <span slot="label"><a-tooltip>{{ $t('通知') }}<template slot="title">{{ $t('通知') }}</template></a-tooltip> </span>
            <a-input v-model="form.notice" :placeholder="$t('请输入')" type="textarea" allow-clear/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row style="padding-bottom: 10px">
        <a-button type="primary" :loading="submitLoading" @click="openGoodsSelect">
          选择商品
        </a-button>
        <a-button @click="handleDeleteAllGoods()" v-if="form.batchGoodsList && form.batchGoodsList.length > 1">
          删除全部商品
        </a-button>
      </a-row>
      <a-row>
        <a-table
          v-if="form.batchGoodsList"
          :loading="loading"
          :size="tableSize"
          rowKey="id"
          :columns="goodsColumns"
          childrenColumnName="ch"
          :data-source="form.batchGoodsList"
          :pagination="false"
          :bordered="tableBordered">
          <template slot="picture" slot-scope="text, record">
            <div>
              <img v-if="record.picture" :src="record.picture"  style="width:60px;height:62px;" @click="handleRecordPreview(record.picture)" alt="none"/>
            </div>
          </template>
          <div slot="goodsName" slot-scope="text, record">
            <a-input :maxLength="100" v-model="record.goodsName"  placeholder="商品名称"  />
          </div>
          <div slot="price" slot-scope="text, record">
            <a-input-number :min="0" :step="0.01" v-model="record.price"  placeholder="价格"  />
          </div>
          <div slot="discountNum" slot-scope="text, record">
            <a-input-number :min="0" :max="999" :step="1" v-model="record.discountNum"  placeholder="优惠数量"  />
          </div>
          <div slot="minBuyNum" slot-scope="text, record">
            <a-input-number :min="0" :max="999" :step="1" v-model="record.minBuyNum"  placeholder="最小限购"  />
          </div>
          <div slot="maxBuyNum" slot-scope="text, record">
            <a-input-number :min="0" :max="999" :step="1" v-model="record.maxBuyNum"  placeholder="最大限购"  />
          </div>
          <div slot="minSize" slot-scope="text, record">
            <a-input-number :min="10" :max="200" :step="1" v-model="record.minSize"  placeholder="开始尺码"  />
          </div>
          <div slot="maxSize" slot-scope="text, record">
            <a-input-number :min="10" :max="200" :step="1" v-model="record.maxSize"  placeholder="结束尺码"  />
          </div>
          <div slot="sort" slot-scope="text, record">
            <a-input-number :min="0" :max="999" :step="1" v-model="record.sort"  placeholder="排序"  />
          </div>
          <span slot="operation" slot-scope="text, record">
            <a @click="handleDeleteGoods(record.goodsId)">
          <a-icon type="delete" />{{$t('删除')}}
        </a>
      </span>
        </a-table>

      </a-row>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
    <uniform-checkbox-select ref="uniformCheckboxSelect" @goodsSelect="indexGoodsSelect"></uniform-checkbox-select>
  </a-drawer>
</template>

<script>
import {getSchoolBatch, addSchoolBatch, updateSchoolBatch, schoolBatchGoodsList} from '@/api/school/schoolBatch'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";
import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";
import moment from 'moment'
import UniformCheckboxSelect from "@/views/goods/goods/select/UniformCheckboxSelect.vue";
import {tableMixin} from "@/store/table-mixin";

export default {
  name: 'CreateForm',
  props: {
  },
  mixins: [tableMixin],
  components: {
    UniformCheckboxSelect,
    CustomDictTag,
    LocaleFieldButton,
  },
  data() {
    return {
      submitLoading: false,
      formTitle: '',
      loading: false,
      goodsColumns: [
        {
          title: '商品名称',
          dataIndex: 'goodsName',
          scopedSlots: {customRender: 'goodsName'},
        },
        {
          title: '图片',
          dataIndex: 'picture',
          scopedSlots: {customRender: 'picture'},
        },
        {
          title: '价格',
          dataIndex: 'price',
          scopedSlots: {customRender: 'price'},
        },
        {
          title: '优惠数量',
          dataIndex: 'discountNum',
          scopedSlots: {customRender: 'discountNum'},
        },
        {
          title: '最小限购',
          dataIndex: 'minBuyNum',
          scopedSlots: {customRender: 'minBuyNum'},
        },
        {
          title: '最大限购',
          dataIndex: 'maxBuyNum',
          scopedSlots: {customRender: 'maxBuyNum'},
        },
        {
          title: '开始尺码',
          dataIndex: 'minSize',
          scopedSlots: {customRender: 'minSize'},
        },
        {
          title: '结束尺码',
          dataIndex: 'maxSize',
          scopedSlots: {customRender: 'maxSize'},
        },
        {
          title: '排序',
          dataIndex: 'sort',
          scopedSlots: {customRender: 'sort'},
        },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: {customRender: 'operation'},
          align: 'center'
        }
      ],
      filteredDeliveryOptions() {
        return this.customDict.DeliveryTypeEnum.filter(g => g.type !== 3);
      },
      // 表单参数
      form: {
        id: null,
        batchName: null,
        batchCode: null,
        batchType: null,
        logisticsType: null,
        mobile: null,
        isShowNotification: false,
        notification: null,
        notice: null,
        startTime: null,
        endTime: null,
        schoolId: null,
        remark: null,
        batchGoodsList: [],
        localeFieldMap: {},
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        batchName: [{required: true, message: this.$t('批次名称') + this.$t('不能为空'), trigger: 'blur'}],
        batchCode: [{required: true, message: this.$t('批次口令') + this.$t('不能为空'), trigger: 'blur'}],
        batchType: [{required: true, message: this.$t('批次标签') + this.$t('不能为空'), trigger: 'change'}],
        logisticsType: [{required: true, message: this.$t('物流类型') + this.$t('不能为空'), trigger: 'change'}],
        isShowNotification: [{required: true, message: this.$t('是否展示公告') + this.$t('不能为空'), trigger: 'change'}],
        notification: [{required: true, message: this.$t('公告内容') + this.$t('不能为空'), trigger: 'blur'}],
        mobile: [{required: true, message: this.$t('客服电话') + this.$t('不能为空'), trigger: 'blur'}],
        startTime: [{required: true, message: this.$t('开始时间') + this.$t('不能为空'), trigger: 'change'}],
        endTime: [{required: true, message: this.$t('结束时间') + this.$t('不能为空'), trigger: 'change'}],
        schoolId: [{required: true, message: this.$t('学校') + this.$t('不能为空'), trigger: 'blur'}]
      }
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    moment,
    onClose() {
      this.cancel()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        batchName: null,
        batchCode: null,
        batchType: null,
        logisticsType: null,
        mobile: null,
        isShowNotification: false,
        notification: null,
        notice: null,
        startTime: null,
        endTime: null,
        schoolId: null,
        deptId: null,
        remark: null,
        batchGoodsList: [],
        localeFieldMap: {},
      }

    },

    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },


    /** 新增按钮操作 */
    handleAdd(schoolId) {
      this.reset()
      if (schoolId) {
        this.form.schoolId = schoolId
      }
      this.formType = 1;
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(id) {
      this.reset()
      this.formType = 2
      getSchoolBatch({"id": id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    openGoodsSelect() {
      let goodsIdList = this.form.batchGoodsList ? this.form.batchGoodsList.map(item => item.goodsId) : [];
      this.$refs.uniformCheckboxSelect.openGoods(goodsIdList, null, 21, this.form.id);
    },
    indexGoodsSelect(id, records) {
      console.log(records, 'records')
      //深拷贝
      const cloneData = JSON.parse(JSON.stringify(records))
      cloneData.forEach(element => {
        element.goodsId = element.id
      })
      //this.form.batchGoodsList 根据 goodsId 判断, 有的就不管, 没有的往 batchGoodsList 里加
      cloneData.forEach(item => {
        let index = this.form.batchGoodsList.findIndex(e => e.goodsId === item.id);
        if (index === -1) {
          let goodsItem = { goodsId: item.id, goodsName: item.goodsName, picture: item.picture, price: item.price, discountNum: 0, minBuyNum: 0, maxBuyNum:0, minSize: 10, maxSize: 200, sort: 1 };
          this.form.batchGoodsList.push(goodsItem);
        }
      });

    },

    handleDeleteGoods(goodsId) {
      let filter = this.form.batchGoodsList.filter(e => e.goodsId !== goodsId);
      this.form.batchGoodsList =filter;
    },

    handleDeleteAllGoods() {
      this.form.batchGoodsList =[];
    },


    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateSchoolBatch(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addSchoolBatch(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
